import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

export const useAuthenticatedAPI = () => {
  const { getToken, logout } = useAuth();
  const navigate = useNavigate();

  const API_BASE_URL = "https://boutiqu.transfoafricainc.com/api";

  const authenticatedFetch = async (url, options = {}) => {
    const token = getToken();

    const headers = {
      ...options.headers,
    };

    // Ne pas définir Content-Type pour FormData - le navigateur le fera automatiquement
    if (!(options.body instanceof FormData)) {
      headers["Content-Type"] = "application/json";
    }

    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }

    try {
      const response = await fetch(url, {
        // CORRECTION ICI - ne pas ajouter API_BASE_URL
        ...options,
        headers,
        credentials: "include",
      });

      if (response.status === 401) {
        logout();
        throw new Error("Session expirée. Veuillez vous reconnecter.");
      }

      if (response.status === 403) {
        throw new Error(
          "Vous n'avez pas les autorisations nécessaires pour cette action."
        );
      }

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || `Erreur ${response.status}`);
      }

      const contentType = response.headers.get("content-type");
      if (contentType && contentType.includes("application/json")) {
        return await response.json();
      }

      return await response.text();
    } catch (error) {
      console.error("Erreur API:", error);
      throw error;
    }
  };

  // Fonctions utilitaires pour les opérations CRUD courantes
  const apiGet = async (endpoint) => {
    return await authenticatedFetch(`${API_BASE_URL}${endpoint}`);
  };

  const apiPost = async (endpoint, data) => {
    return await authenticatedFetch(`${API_BASE_URL}${endpoint}`, {
      method: "POST",
      body: data instanceof FormData ? data : JSON.stringify(data),
    });
  };

  const apiPut = async (endpoint, data) => {
    return await authenticatedFetch(`${API_BASE_URL}${endpoint}`, {
      method: "PUT",
      body: data instanceof FormData ? data : JSON.stringify(data),
    });
  };

  const apiDelete = async (endpoint) => {
    return await authenticatedFetch(`${API_BASE_URL}${endpoint}`, {
      method: "DELETE",
    });
  };

  return {
    authenticatedFetch,
    apiGet,
    apiPost,
    apiPut,
    apiDelete,
    API_BASE_URL,
  };
};
